module.exports = __webpack_public_path__ + "img/win_item8.256935b2.png";